import { CoinsProvider } from './../../providers/coins/coins';
import { CMC } from './../../models/CoinMarketCap';
import { Component, Output, EventEmitter } from '@angular/core';
import { Coin } from '../../models/Coin';
import { ViewController } from 'ionic-angular';


/**
 * Generated class for the CoinSearchComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'coin-search',
  templateUrl: 'coin-search.html'
})
export class CoinSearchComponent {
  @Output() coin: EventEmitter<Coin> = new EventEmitter<Coin>();

  searchQuery: string = '';
  items: Coin[] = [];
  allCoinsArray: Coin[] = [];

  MAX_ITEMS: number = 30;

  constructor(public CP: CoinsProvider, public viewCtrl: ViewController) {
    CP.getAllCoins().subscribe((coins: CMC.AllCoins) => {
      this.allCoinsArray = this.getCoinArray(coins);
      this.sortCoins();
      this.getNextItems();
    });
  }

  getNextItems(){
    let coins = [];

    //We have a search query
    if (this.searchQuery && this.searchQuery.trim() != '') {
      coins = this.allCoinsArray.filter((item) => {
        return (item.FullName.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1);
      })
    }else{ //Give me all coins
      coins = this.allCoinsArray;
    }

    let newItems: Coin[] = []; // holds the next 10 items in the array (or less)

    let end = (coins.length < this.MAX_ITEMS ? coins.length : this.MAX_ITEMS);

    for(let i = 0; i < end; i++){
      newItems.push(coins[i]);
    }

    for(let coin of newItems){
      this.items.push(coin);
    }
  }

  searchItems(ev: any) {
    this.searchQuery = ev.target.value;
    this.initializeItems();
  }

  initializeItems(){
    this.items = [];
    this.getNextItems();
  }

  selectCoin(coin: Coin){
    this.viewCtrl.dismiss(coin);
    this.coin.emit(coin);
  }

  private sortCoins(){
    this.allCoinsArray.sort(function(a, b){
      return a.Name.localeCompare(b.Name);
    });
  }

  private getCoinArray(allCoins: CMC.AllCoins): Coin[]{
    let coins: Coin[] = []
    for(let coin in allCoins){
      coins.push(allCoins[coin]);
    }
    return coins;
  }

  dismiss(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/coin-search/coin-search.ts